<template>
  <div class="lifemanage">
    <search-list @project="findList" class="mb16"></search-list>
    <div>

      <table-list
        :columns="columns"
        :data="data1"
        :total="total"
        :loading="loading"
        @change-page="getPage"
        @change-size="getSize"
      ></table-list>
    </div>
    <set-modal :n="key" :projectFid="id" @refresh="initTable"></set-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import SearchList from "./components/SearchList";
import TableList from "components/TableList/index";
import SetModal from "./components/SetModal";
import { getList } from "api/waterAndElectricity";
export default {
  name: "waterelectricity",
  components: {
    SearchList,
    TableList,
    SetModal
  },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 100,
          align: "center"
        },

        {
          title: "项目名称",
          align: "center",
          key: "projectName",
          width: 220,
          className: 'fy--table-border_right',
        },
        {
          title: "客户",
          align: "center",
          width: 220,
          className: 'fy--table-border_right',
          children: [
            {
              title: "冷水",
              align: "center",
              key: "coldWater",
              width: 220,
              render: (h, params) => {
                if (params.row.customer &&  params.row.customer.coldWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.customer.coldWater[0]
                    ),
                    h("span", {}, params.row.customer.coldWater[1]),
                    h("span", {}, params.row.customer.coldWater[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "电",
              align: "center",
              key: "electricity",
              width: 220,
              render: (h, params) => {
                if (params.row.customer && params.row.customer.electricity) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          border: "1px solid rgb(220,220,220)",
                          color: "#F2BA49"
                        }
                      },
                      params.row.customer.electricity[0]
                    ),
                    h("span", {}, params.row.customer.electricity[1]),
                    h("span", {}, params.row.customer.electricity[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "燃气",
              align: "center",
              key: "gas",
              width: 220,
              render: (h, params) => {
                if (params.row.customer && params.row.customer.gas) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.customer.gas[0]
                    ),
                    h("span", {}, params.row.customer.gas[1]),
                    h("span", {}, params.row.customer.gas[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "热水",
              align: "center",
              key: "hotWater",
              width: 220,
              render: (h, params) => {
                if (params.row.customer && params.row.customer.hotWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.customer.hotWater[0]
                    ),
                    h("span", {}, params.row.customer.hotWater[1]),
                    h("span", {}, params.row.customer.hotWater[2])
                  ]);
                } else {
                  return h('div',{},'');
                }
              }
            },
            {
              title: "中水",
              align: "center",
              key: "zhongWater",
              width: 220,
              className: 'fy--table-border_right',
              render: (h, params) => {
                if (params.row.customer && params.row.customer.zhongWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.customer.zhongWater[0]
                    ),
                    h("span", {}, params.row.customer.zhongWater[1]),
                    h("span", {}, params.row.customer.zhongWater[2])
                  ]);
                } else {
                  return;
                }
              }
            }
          ]
        },
        {
          title: "业主",
          align: "center",
          width: 220,
          children: [
            {
              title: "冷水",
              align: "center",
              key: "coldWater",
              width: 220,
              render: (h, params) => {
                if (params.row.owner && params.row.owner.coldWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.owner.coldWater[0]
                    ),
                    h("span", {}, params.row.owner.coldWater[1]),
                    h("span", {}, params.row.owner.coldWater[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "电",
              align: "center",
              key: "electricity",
              width: 220,
              render: (h, params) => {
                if (params.row.owner && params.row.owner.electricity) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          border: "1px solid rgb(220,220,220)",
                          color: "#F2BA49"
                        }
                      },
                      params.row.owner.electricity[0]
                    ),
                    h("span", {}, params.row.owner.electricity[1]),
                    h("span", {}, params.row.owner.electricity[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "燃气",
              align: "center",
              key: "gas",
              width: 220,
              render: (h, params) => {
                if (params.row.owner && params.row.owner.gas) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.owner.gas[0]
                    ),
                    h("span", {}, params.row.owner.gas[1]),
                    h("span", {}, params.row.owner.gas[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "热水",
              align: "center",
              key: "hotWater",
              width: 220,
              render: (h, params) => {
                if (params.row.owner && params.row.owner.hotWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.owner.hotWater[0]
                    ),
                    h("span", {}, params.row.owner.hotWater[1]),
                    h("span", {}, params.row.owner.hotWater[2])
                  ]);
                } else {
                  return;
                }
              }
            },
            {
              title: "中水",
              align: "center",
              key: "zhongWater",
              width: 220,
              render: (h, params) => {
                if (params.row.owner && params.row.owner.zhongWater) {
                  return h("div", {}, [
                    h(
                      "span",
                      {
                        style: {
                          width: "90px",
                          height: "90px",
                          padding: "0px 4.5px 0px 4.5px",
                          color: "#F2BA49",
                          border: "1px solid rgb(220,220,220)"
                        }
                      },
                      params.row.owner.zhongWater[0]
                    ),
                    h("span", {}, params.row.owner.zhongWater[1]),
                    h("span", {}, params.row.owner.zhongWater[2])
                  ]);
                } else {
                  return;
                }
              }
            }
          ]
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h(
              "Button",
              {
                directives: [
                  {
                    name: "p",
                    value: {
                      api: "waterwatt/settings/save"
                    }
                  }
                ],
                props: {
                  type: "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.key++;
                    this.id = params.row.projectFid;
                  }
                }
              },
              "修改"
            );
          }
        }
      ],
      data1: [],
      total: 0,
      key: 0,
      params: {
        limit: 10,
        page: 1,
        projectFid: ""
      },
      loading: false,
      id: ""
    };
  },
  created() {
    this.initTable();
  },
  methods: {
    getPage(n) {
      this.params.page = n;
      this.initTable();
    },
    initTable() {
      this.loading = true;
      getList(this.params)
        .then(res => {
          this.loading = false;
          this.data1 = res.data.rows;
          this.total = res.data.total;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    findList(id) {
      this.params.projectFid = id;
      this.initTable();
    },
    getSize(size) {
      this.params.limit = size;
      this.initTable();
    }
  }
};
</script>
<style >
  .fy--table-border_right{
    border-right: 1px solid rgb(217, 215, 218);
  }
</style>
